import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './locales/en';
import de from './locales/de';

Vue.use(VueI18n);

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'de-DE',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'de-DE',
  messages: {
    ...en.messages, ...de.messages
  },
  numberFormats: { ...de.numbers },
  dateTimeFormats: { ...de.dates, ...en.dates }
});
